import router from "@/router/";
import axios from "axios";
import { Message } from "element-ui";
import qs from "qs";
import { makeFormData } from "../utils/utils";
const whiteList = ["v2/web/invoice/cancel"];
let requestInfo = {
  url: "",
  status: true
};
localStorage.setItem("requestInfo", JSON.stringify(requestInfo));

const service = axios.create();

// request interceptor 请求拦截
service.interceptors.request.use(
  config => {
    if (config.url.indexOf("diablo.ruigushop.com") > -1) {
      config.headers["token"] = localStorage.getItem("token");
    }
    if (config.url.indexOf("rbox.ruigushop.com/agent-platform") > -1) {
      config.headers["Authorization"] = localStorage.getItem("token");
    }

    return config;
  },
  error => {
    // Do something with request error
    console.log("请求错误", error); // for debug
    Promise.reject(error);
  }
);

// response interceptor 响应拦截
service.interceptors.response.use(
  response => {
    return response;
  },
  async error => {
    if (error.response.status != 200) {
      Message.error(error.response.data.message);
    }
    return Promise.reject(error);
  }
);
const api = {
  async get(url, params = {}) {
    params.token = localStorage.getItem("token");
    params.shop_id = localStorage.getItem("shop_id");
    // if (JSON.parse(localStorage.getItem('requestInfo')) && JSON.parse(localStorage.getItem('requestInfo')).url === url && JSON.parse(localStorage.getItem('requestInfo')).status === false) {
    //   Message.warning('请等待')
    // } else {
    try {
      requestInfo.url = url;
      requestInfo.status = false;
      localStorage.setItem("requestInfo", JSON.stringify(requestInfo));
      let res = await service.get(url, {
        params: params,
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        }
      });
      requestInfo.status = true;
      localStorage.setItem("requestInfo", JSON.stringify(requestInfo));
      res = res.data;
      return new Promise(resolve => {
        if (res.code === 200) {
          resolve(res);
        } else if (res.msg.includes("请登录")) {
          Message.error(res.msg);
          setTimeout(() => {
            localStorage.clear();
            router.push("/login");
          }, 1000);
        } else {
          if (whiteList.some(item => url.indexOf(item) === -1)) {
            Message.error(res.message);
          }
          resolve(res);
        }
      });
    } catch (err) {
      Message.error("请求失败");
      requestInfo.status = true;
      localStorage.setItem("requestInfo", JSON.stringify(requestInfo));
      console.log(err);
    }
    // }
  },
  async post(url, params = {}) {
    if (
      JSON.parse(localStorage.getItem("requestInfo")) &&
      JSON.parse(localStorage.getItem("requestInfo")).url === url &&
      JSON.parse(localStorage.getItem("requestInfo")).status === false
    ) {
      Message.warning("请等待");
    } else {
      try {
        requestInfo.url = url;
        requestInfo.status = false;
        localStorage.setItem("requestInfo", JSON.stringify(requestInfo));
        let formdata = new FormData();
        formdata.append("shop_id", localStorage.getItem("shop_id"));
        formdata.append("token", localStorage.getItem("token"));
        if (params) {
          makeFormData(params, formdata);
        }
        if (params.formData) {
          formdata.set("formData", params.formData);
        }
        let res = await service.post(url, formdata, {
          // headers: {
          //   "X-code": "diabol"
          // }
        });
        requestInfo.status = true;
        localStorage.setItem("requestInfo", JSON.stringify(requestInfo));
        res = res.data;
        return new Promise((resolve, reject) => {
          if (res.code === 200) {
            resolve(res);
          } else if (res.msg === "请登录") {
            Message.error(res.msg);
            setTimeout(() => {
              localStorage.clear();
              router.push("/login");
            }, 1000);
          } else {
            if (whiteList.some(item => url.indexOf(item) === -1)) {
              Message.error(res.message);
            }

            reject(res);
          }
        });
      } catch (err) {
        // Message.error("请求失败");
        requestInfo.status = true;
        localStorage.setItem("requestInfo", JSON.stringify(requestInfo));
        console.log(err);
        // return err;
        // return new Promise((resolve, reject) => {})
      }
    }
  }
};
export { api };
export const get = function(url, params) {
  return new Promise((resolve, reject) => {
    // console.log(params)
    api
      .get(url, params)
      .then(function(res) {
        if (res.code === 200) {
          resolve(res);
        } else {
          reject(res);
        }
        // console.log(res.data)
      })
      .catch(function(err) {
        reject(err);
      });
  });
};
export const post = function(url, params) {
  return new Promise((resolve, reject) => {
    api
      .post(url, params)
      .then(function(res) {
        if (res.code === 200) {
          resolve(res);
        } else {
          reject(res);
        }
      })
      .catch(function(err) {
        reject(err);
      });
  });
};

// Body 形式传参
export async function postJson(url, params = "") {
  return new Promise((resolve, reject) => {
    // axios
    service
      .post(url, qs.stringify(params), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
      .then(res => {
        if (res.data.code === 200) {
          resolve(res.data.data || { result: true });
        } else if (res.data.msg === "请登录") {
          Message.error(res.msg);
          setTimeout(() => {
            localStorage.clear();
            router.push("/login");
          }, 1000);
        } else {
          reject(res.data);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * post请求 form
 * @param url api url
 * @param data data
 */
export async function postForm(url = "", data = {}) {
  return new Promise((resolve, reject) => {
    // axios
    service
      .post(url, data, { postType: "form" })
      .then(res => {
        if (res.data.code === 200) {
          resolve(res.data.data || { result: true });
        } else {
          reject(res.data);
        }
      })
      .catch(err => {
        reject(err.response.data);
      });
  });
}



// WEBPACK FOOTER //
// ./src/service/api.js